export var printInvoiceTestData = {
    id: 2,
    fact_new_do_id: 9,
    dim_mst_invoice_status_id: 5,
    dim_mst_payment_type_id: 2,
    dim_mst_price_category_id: 2,
    dim_new_alldernow_emp_id: 97,
    fact_member_id: 8993,
    doc_number: "IVT-250700002",
    do_doc_number_ref: "DO-250700002",
    full_member_name: "ห้างหุ้นส่วนจำกัด เฮียอู๊ด ฟู้ด เรสเตอรองท์",
    full_member_address_name: "12/14 ถนนรอบเวียงประตูกลอง ต.เวียง อ.เมืองพะเยา จ.พะเยา 56000",
    member_is_hq: true,
    member_branch_no: "00000",
    member_additional_info: null,
    member_business_type: "โรงแรม/ร้านอาหารกลาง / สวนอาหาร",
    member_customer_type: "ห้างหุ้นส่วนจำกัด",
    member_address: "12/14 ถนนรอบเวียงประตูกลอง",
    member_district: "เวียง",
    member_amphoe: "เมืองพะเยา",
    member_province: "พะเยา",
    member_postal_code: "56000",
    member_phone_number: "0899556459",
    dim_branch_id: 3,
    refer: "",
    dim_mst_discount_type_id: 1,
    discount_value: 0,
    total_price_before_discount: 8750,
    discount_price: 0,
    total_price_after_discount: 8750,
    total_price_product_no_vat: 0,
    total_price_product_zero_vat: 0,
    total_price_product_seven_vat: 8177.5701,
    total_seven_vat_amount: 572.4299,
    total_price_vat: 572.4299,
    total_price_before_vat: 8177.5701,
    grand_total_price: 8750,
    total_paid_price: 8750,
    total_outstanding_price: 0,
    sum_item_quantity: 20,
    remark: "",
    doc_issue_date: "2025-07-07T00:00:00.000Z",
    doc_due_date: "2025-07-07T00:00:00.000Z",
    is_sort_manual: false,
    is_tax_invoice: true,
    is_submitted: true,
    is_receipt_created: true,
    not_approve_reason: "",
    canceled_at: null,
    canceled_by_emp_id: null,
    updated_wait_approve_at: null,
    updated_approve_at: "2025-07-07T11:17:31.000Z",
    submitted_at: "2025-07-07T11:27:00.000Z",
    updated_success_at: "2025-07-07T11:27:00.000Z",
    created_at: "2025-07-07T11:17:31.000Z",
    updated_at: "2025-07-07T11:27:04.000Z",
    dimMstDiscountType: {
        id: 1,
        name: "%",
        is_active: true,
        created_at: "2024-08-31T20:40:24.000Z",
        updated_at: "2024-08-31T20:40:24.000Z"
    },
    factNewInvoiceItem: [
        {
            id: 2,
            fact_new_invoice_id: 2,
            fact_new_do_item_id: 33,
            dim_product_price_id: 8806,
            unit_id: 2,
            ratio_unit: 12,
            container: "1x12",
            quantity: 10,
            avg_discount_before_vat: 607.4766,
            unit_price: 680,
            dim_mst_discount_type_id: 2,
            discount_value: 30,
            discount_price: 30,
            dim_mst_vat_id: 3,
            total_price_before_vat: 6074.7664,
            total_price_include_vat: 6500,
            remark: null,
            created_at: "2025-07-07T11:17:31.000Z",
            updated_at: "2025-07-07T11:17:31.000Z",
            dimMasterUnit: {
                id: 2,
                name: "ลัง",
                desc: "ลัง",
                is_active: true,
                created_at: "2021-05-05T20:38:04.000Z",
                updated_at: "2021-05-05T20:38:04.000Z"
            },
            dimMstVat: {
                id: 3,
                name: "7 %",
                value: 7,
                is_active: true,
                created_at: "2024-08-31T20:40:26.000Z",
                updated_at: "2024-08-31T20:40:26.000Z"
            },
            dimProductPrice: {
                id: 8806,
                product_id: 1391,
                barcode: "18858776300492",
                code_sales: null,
                price_1: 680,
                price_2: 0,
                price_3: 0,
                price_4: 0,
                price_5: 0,
                unit_id: 2,
                ratio_unit: 12,
                container: "1x12",
                is_new: false,
                is_new_sort: 0,
                is_hot: false,
                is_hot_sort: 0,
                is_web: false,
                width: 0,
                length: 0,
                height: 0,
                weight: 0,
                weight_name: null,
                is_web_flash_sales: false,
                price_flash_sales: 0,
                number_per_person_flash_sales: 0,
                number_per_product: 0,
                number_flash_sales_use: 0,
                is_come_on: false,
                is_promotion_web: false,
                promotion_web_discount: 0,
                is_delete: false,
                created_at: "2021-05-09T22:32:53.000Z",
                updated_at: "2025-04-19T16:35:56.000Z",
                deleted_at: null,
                dimProduct: {
                    id: 1391,
                    sku: "1302024",
                    barcode: "8858776300488",
                    name_th: "โบนัส น้ำมันปาล์มถุงเติม 1ลิตร",
                    name_en: "โบนัส น้ำมันปาล์มถุงเติม 1ลิตร",
                    supplier_names: [
                        "โบนัสน้ำมันปาล์มถุงเติม1ล."
                    ],
                    supplier_code: "104884",
                    formula_id: null,
                    family_id: null,
                    category_id: 1,
                    sub_category_id: 3,
                    sub_category_2_id: 18,
                    divition_id: null,
                    brand_id: 280,
                    desc: null,
                    sub_unit_id: 7,
                    unit_id: 2,
                    ratio_sub_unit: 12,
                    sub_unit_cost: 57.92,
                    unit_cost: 695.04,
                    vat: "VAT 7%",
                    minimum_sales: null,
                    packing_size_name_th: "ลิตร",
                    packing_size_th: 1,
                    packing_size_name_en: null,
                    packing_size_en: null,
                    registration_number: null,
                    tisi: null,
                    weight: null,
                    weight_name: null,
                    wide: null,
                    long: null,
                    height: null,
                    dimension_unit: null,
                    storage_id: null,
                    initial_product_quantity: null,
                    minimum_alert: null,
                    over_stock: null,
                    is_able_sell_negative: null,
                    remark: null,
                    user_id: null,
                    is_web: false,
                    is_closed: false,
                    is_delete: false,
                    created_at: "2021-05-09T22:17:53.000Z",
                    updated_at: "2025-03-04T13:01:31.000Z",
                    deleted_at: null
                }
            }
        },
        {
            id: 3,
            fact_new_invoice_id: 2,
            fact_new_do_item_id: 34,
            dim_product_price_id: 23797,
            unit_id: 25,
            ratio_unit: 1,
            container: "1x1",
            quantity: 10,
            avg_discount_before_vat: 210.2804,
            unit_price: 235,
            dim_mst_discount_type_id: 2,
            discount_value: 10,
            discount_price: 10,
            dim_mst_vat_id: 3,
            total_price_before_vat: 2102.8037,
            total_price_include_vat: 2250,
            remark: null,
            created_at: "2025-07-07T11:17:31.000Z",
            updated_at: "2025-07-07T11:17:31.000Z",
            dimMasterUnit: {
                id: 25,
                name: "กระป๋อง",
                desc: "กระป๋อง",
                is_active: true,
                created_at: "2021-05-09T21:24:01.000Z",
                updated_at: "2021-05-09T21:24:16.000Z"
            },
            dimMstVat: {
                id: 3,
                name: "7 %",
                value: 7,
                is_active: true,
                created_at: "2024-08-31T20:40:26.000Z",
                updated_at: "2024-08-31T20:40:26.000Z"
            },
            dimProductPrice: {
                id: 23797,
                product_id: 8350,
                barcode: "041790600186",
                code_sales: null,
                price_1: 235,
                price_2: null,
                price_3: null,
                price_4: null,
                price_5: null,
                unit_id: 25,
                ratio_unit: 1,
                container: "1x1",
                is_new: false,
                is_new_sort: 0,
                is_hot: false,
                is_hot_sort: 0,
                is_web: false,
                width: 0,
                length: 0,
                height: 0,
                weight: 0,
                weight_name: null,
                is_web_flash_sales: false,
                price_flash_sales: 0,
                number_per_person_flash_sales: 0,
                number_per_product: 0,
                number_flash_sales_use: 0,
                is_come_on: false,
                is_promotion_web: false,
                promotion_web_discount: 0,
                is_delete: false,
                created_at: "2025-03-05T18:38:47.000Z",
                updated_at: "2025-03-05T18:38:47.000Z",
                deleted_at: null,
                dimProduct: {
                    id: 8350,
                    sku: "1302050",
                    barcode: "041790600186",
                    name_th: "Bertolli เบอร์ทอลลี่ สเปรย์น้ำมันมะกอกเอ็กซ์ตร้าไลท์ 145ml",
                    name_en: null,
                    supplier_names: [
                        "BERTOLLI EXTRA LIGHT O/OIL SPRAY"
                    ],
                    supplier_code: "600186",
                    formula_id: null,
                    family_id: null,
                    category_id: 1,
                    sub_category_id: 3,
                    sub_category_2_id: 18,
                    divition_id: null,
                    brand_id: 439,
                    desc: null,
                    sub_unit_id: 25,
                    unit_id: 2,
                    ratio_sub_unit: 6,
                    sub_unit_cost: 211.5,
                    unit_cost: 1269,
                    vat: "VAT 7%",
                    minimum_sales: null,
                    packing_size_name_th: "มิลลิลิตร",
                    packing_size_th: 145,
                    packing_size_name_en: null,
                    packing_size_en: null,
                    registration_number: null,
                    tisi: null,
                    weight: null,
                    weight_name: null,
                    wide: null,
                    long: null,
                    height: null,
                    dimension_unit: null,
                    storage_id: null,
                    initial_product_quantity: null,
                    minimum_alert: null,
                    over_stock: null,
                    is_able_sell_negative: null,
                    remark: null,
                    user_id: 26,
                    is_web: false,
                    is_closed: false,
                    is_delete: false,
                    created_at: "2025-03-05T18:38:47.000Z",
                    updated_at: "2025-03-16T14:50:25.000Z",
                    deleted_at: null
                }
            }
        }
    ],
    factItemInvoiceColSort: [],
    factTagInvoice: [],
    factDocFileInvoice: [],
    createdNewInvoiceEmp: {
        id: 97,
        dim_mst_prefix_id: 1,
        dim_mst_sex_id: null,
        dim_mst_marital_status_id: null,
        dim_mst_military_status_id: null,
        dim_branch_id: 3,
        emp_code: "SPADMIN01",
        img_path: null,
        first_name_th: "ซุปเปอร์แอดมิน",
        last_name_th: "ซุปเปอร์แอดมิน",
        first_name_en: null,
        last_name_en: null,
        id_card: null,
        nick_name: null,
        birth_date: null,
        age: null,
        ethnicity: null,
        nationality: null,
        dim_mst_relationship_id: null,
        address: null,
        sub_district: null,
        district: null,
        province: null,
        postal_code: null,
        email: "superadmin@admin.com",
        phone_number: null,
        line: null,
        facebook: null,
        instagram: null,
        emergency_contact_person: null,
        emergency_phone_number: null,
        dim_mst_bank_id: null,
        dim_mst_bank_account_type_id: null,
        is_bank_account: false,
        bank_account_name: null,
        bank_account_number: null,
        bank_account_branch_name: null,
        bank_account_branch_number: null,
        dim_mst_employee_type_id: null,
        dim_mst_department_id: null,
        dim_mst_position_id: null,
        start_date: null,
        end_date: null,
        is_register_social_security: false,
        cancel_by_user_id: null,
        deleted_at: null,
        created_at: "2024-08-31T08:39:01.000Z",
        updated_at: "2024-08-31T08:39:01.000Z"
    },
    dimMstInvoiceStatus: {
        id: 5,
        name: "ชำระแล้ว",
        is_active: true,
        created_at: "2025-07-07T09:38:05.000Z",
        updated_at: "2025-07-07T09:38:05.000Z"
    },
    factMember: {
        id: 8993,
        customer_id: "CM2021102571",
        customer_type: "ห้างหุ้นส่วนจำกัด",
        tax_id: null,
        prefix_name: null,
        first_name: null,
        last_name: null,
        prefix_comp_name: "ห้างหุ้นส่วนจำกัด",
        comp_name: "เฮียอู๊ด ฟู้ด เรสเตอรองท์",
        comp_last_name: null,
        phone_number: "0899556459",
        new_phone_number: null,
        birth_date: null,
        group_customer: null,
        price_type: null,
        business_name: null,
        bussiness_type: "โรงแรม/ร้านอาหารกลาง / สวนอาหาร",
        point: 10268,
        junecoin: 0,
        register_form: "Line LIFF",
        cti_tax_id: "0563564000114",
        is_cti_hq: true,
        cti_branch_no: "00000",
        additional_info: null,
        cti_type: "ห้างหุ้นส่วนจำกัด",
        cti_prefix: "ห้างหุ้นส่วนจำกัด",
        cti_name: "เฮียอู๊ดฟู๊ด เรสเตอรองท์",
        cti_suffix: null,
        cti_email: null,
        cti_address: "12/14 ถนนรอบเวียงประตูกลอง",
        cti_district: "เวียง",
        cti_amphoe: "เมืองพะเยา",
        cti_province: "พะเยา",
        cti_postal_code: "56000",
        pti_tax_id: null,
        pti_type: null,
        pti_prefix: null,
        pti_firstname: null,
        pti_lastname: null,
        pti_co_prefix: null,
        pti_co_name: null,
        pti_co_suffix: null,
        pti_email: null,
        pti_address: null,
        pti_district: null,
        pti_amphoe: null,
        pti_province: null,
        pti_postal_code: null,
        is_bo_sale: true,
        created_at: "2021-10-01T11:37:53.000Z",
        updated_at: "2025-06-03T17:05:42.000Z"
    },
    dimMstPaymentType: {
        id: 2,
        name: "เครดิต",
        is_active: true,
        created_at: "2024-08-31T20:40:25.000Z",
        updated_at: "2024-08-31T20:40:25.000Z"
    },
    factNewDo: {
        id: 9,
        fact_new_so_id: 12,
        dim_mst_do_status_id: 4,
        dim_mst_payment_type_id: 2,
        dim_mst_price_category_id: 2,
        dim_new_alldernow_emp_id: 97,
        fact_member_id: 8993,
        doc_number: "DO-250700002",
        so_doc_number_ref: "SO-250700001",
        full_member_name: "ห้างหุ้นส่วนจำกัด เฮียอู๊ด ฟู้ด เรสเตอรองท์",
        full_member_address_name: "12/14 ถนนรอบเวียงประตูกลอง ต.เวียง อ.เมืองพะเยา จ.พะเยา 56000",
        member_is_hq: true,
        member_branch_no: "00000",
        member_additional_info: null,
        member_business_type: "โรงแรม/ร้านอาหารกลาง / สวนอาหาร",
        member_customer_type: "ห้างหุ้นส่วนจำกัด",
        member_address: "12/14 ถนนรอบเวียงประตูกลอง",
        member_district: "เวียง",
        member_amphoe: "เมืองพะเยา",
        member_province: "พะเยา",
        member_postal_code: "56000",
        member_phone_number: "0899556459",
        dim_warehouse_id: 3,
        dim_branch_id: 3,
        refer: "",
        dim_mst_discount_type_id: 1,
        discount_value: 0,
        total_price_before_discount: 8750,
        discount_price: 0,
        total_price_after_discount: 8750,
        total_price_product_no_vat: 0,
        total_price_product_zero_vat: 0,
        total_price_product_seven_vat: 8177.5701,
        total_seven_vat_amount: 572.4299,
        total_price_vat: 572.4299,
        total_price_before_vat: 8177.5701,
        grand_total_price: 8750,
        sum_item_quantity: 20,
        sum_item_so_quantity: 20,
        total_delivered_quantity: 20,
        total_remaining_quantity: 0,
        remark: "",
        doc_issue_date: "2025-07-07T00:00:00.000Z",
        delivery_date: "2025-07-07T00:00:00.000Z",
        is_ready_to_delivery: true,
        ready_to_delivery_date: "2025-07-07T11:16:43.000Z",
        is_delivery_success: true,
        undelivered_reason: "",
        is_sort_manual: true,
        not_approve_reason: "",
        canceled_at: null,
        updated_success_delivery_at: "2025-07-07T00:00:00.000Z",
        canceled_by_emp_id: null,
        updated_wait_approve_at: null,
        updated_approve_at: "2025-07-07T11:16:35.000Z",
        created_at: "2025-07-07T11:16:35.000Z",
        updated_at: "2025-07-07T11:16:51.000Z",
        dimMstDoStatus: {
            id: 4,
            name: "เสร็จสิ้น",
            is_active: true,
            created_at: "2025-06-03T00:44:43.000Z",
            updated_at: "2025-07-07T09:38:03.000Z"
        },
        createdNewDoEmp: {
            id: 97,
            dim_mst_prefix_id: 1,
            dim_mst_sex_id: null,
            dim_mst_marital_status_id: null,
            dim_mst_military_status_id: null,
            dim_branch_id: 3,
            emp_code: "SPADMIN01",
            img_path: null,
            first_name_th: "ซุปเปอร์แอดมิน",
            last_name_th: "ซุปเปอร์แอดมิน",
            first_name_en: null,
            last_name_en: null,
            id_card: null,
            nick_name: null,
            birth_date: null,
            age: null,
            ethnicity: null,
            nationality: null,
            dim_mst_relationship_id: null,
            address: null,
            sub_district: null,
            district: null,
            province: null,
            postal_code: null,
            email: "superadmin@admin.com",
            phone_number: null,
            line: null,
            facebook: null,
            instagram: null,
            emergency_contact_person: null,
            emergency_phone_number: null,
            dim_mst_bank_id: null,
            dim_mst_bank_account_type_id: null,
            is_bank_account: false,
            bank_account_name: null,
            bank_account_number: null,
            bank_account_branch_name: null,
            bank_account_branch_number: null,
            dim_mst_employee_type_id: null,
            dim_mst_department_id: null,
            dim_mst_position_id: null,
            start_date: null,
            end_date: null,
            is_register_social_security: false,
            cancel_by_user_id: null,
            deleted_at: null,
            created_at: "2024-08-31T08:39:01.000Z",
            updated_at: "2024-08-31T08:39:01.000Z"
        }
    },
    factNewInvPayment: [
        {
            id: 2,
            fact_new_invoice_id: 2,
            dim_mst_withholding_tax_id: null,
            pay_date: "2025-07-07T00:00:00.000Z",
            withholding_tax_price: 0,
            total_amount_inc_whtax: 8750,
            total_amount_exc_whtax: 8750,
            total_payment_row_price: 8750,
            total_cut_payment_doc_price: 0,
            total_adjustment_or_fee_price: 0,
            has_payment_rows: true,
            has_cut_payment_docs: false,
            has_adjustment_or_fees: false,
            is_withholding_tax: false,
            created_at: "2025-07-07T11:20:44.000Z",
            updated_at: "2025-07-07T11:20:44.000Z",
            factNewInvPaymentRow: [
                {
                    id: 2,
                    fact_new_inv_payment_id: 2,
                    dim_branch_payment_channel_id: 6,
                    dim_mst_bank_id: null,
                    bank_account_name: "บจก.ค้าขายมั่งมี จำกัด",
                    bank_branch: "ถนนแจ้งวัฒนะ",
                    account_type: "กระแสรายวัน",
                    account_number: "203-1-87899-6",
                    price: 8750,
                    remark: null,
                    created_at: "2025-07-07T11:20:44.000Z",
                    updated_at: "2025-07-07T11:20:44.000Z",
                    dimBranchPaymentChannel: {
                        id: 6,
                        dim_mst_payment_channel_id: 2,
                        dim_mst_bank_id: 2,
                        dim_branch_id: 3,
                        bank_account_name: "บจก.ค้าขายมั่งมี จำกัด",
                        bank_branch: "ถนนแจ้งวัฒนะ",
                        account_type: "กระแสรายวัน",
                        account_number: "203-1-87899-6",
                        is_active: true,
                        created_at: "2025-07-07T09:37:57.000Z",
                        updated_at: "2025-07-07T09:37:57.000Z",
                        dimMstPaymentChannel: {
                            id: 2,
                            name: "เงินโอน",
                            is_active: true,
                            created_at: "2025-07-07T09:37:54.000Z",
                            updated_at: "2025-07-07T09:37:54.000Z"
                        }
                    }
                }
            ],
            factNewInvAdjustmentOrFee: []
        }
    ],
    dimMstBranch: {
        id: 3,
        branch_code: "PYO-001",
        name: "สำนักงานใหญ่",
        address: "1065/1 ถ.พหลโยธิน",
        district: "เวียง",
        amphoe: "เมืองพะเยา",
        province: "พะเยา",
        postal_code: "56000",
        url_google_map: null,
        warehouse_id: 3,
        created_at: "2021-09-29T09:47:50.000Z",
        updated_at: "2024-09-29T22:09:24.000Z",
        is_head_office: true,
        revenue_department_number: "00000",
        dimBranchPaymentChannel: [
            {
                id: 5,
                dim_mst_payment_channel_id: 1,
                dim_mst_bank_id: null,
                dim_branch_id: 3,
                bank_account_name: null,
                bank_branch: null,
                account_type: null,
                account_number: null,
                is_active: true,
                created_at: "2025-07-07T09:37:57.000Z",
                updated_at: "2025-07-07T09:37:57.000Z",
                dimMstBank: null
            },
            {
                id: 6,
                dim_mst_payment_channel_id: 2,
                dim_mst_bank_id: 2,
                dim_branch_id: 3,
                bank_account_name: "บจก.ค้าขายมั่งมี จำกัด",
                bank_branch: "ถนนแจ้งวัฒนะ",
                account_type: "กระแสรายวัน",
                account_number: "203-1-87899-6",
                is_active: true,
                created_at: "2025-07-07T09:37:57.000Z",
                updated_at: "2025-07-07T09:37:57.000Z",
                dimMstBank: {
                    id: 2,
                    logo_path: "banks/KBANK.png",
                    name: "กสิกรไทย",
                    is_active: true,
                    created_at: "2024-08-31T08:38:00.000Z",
                    updated_at: "2025-07-07T09:37:55.000Z"
                }
            }
        ]
    },
    canceledByEmp: null
};
